export const NewWork = () => {
  return (
    <div className="flex justify-center bg-gradient-to-b from-[#FFFFFF] via-[#F8F6FF] via-[#E8F3FF] to-[#FFFFFF]">
      <div className="w-[1920px] px-[240px] pt-[135px] pb-[128px]">
        <div className="flex gap-[81px]">
          <div className="flex-1  pt-[11px]">
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-bold text-[40px] text-[#333333]">
              企业私有化组网
            </div>
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-bold text-[40px] text-[#333333]">
              为企业打造一张自己的专有网络
            </div>
            <div className="bg-gradient-to-r from-[#619BFF] to-[rgba(198,225,255,0)] rounded-[10px] px-[10px] py-[4px] mt-[26px] max-w-[400px]">
              <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-regular text-[25px] text-[#FFFFFF]">
                私有化组网服务介绍
              </div>
            </div>
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-light text-[20px] text-[#333333] mt-[30px]">
              通过光年K-WAN组网方案，帮助出海企业快速的搭建一张自己的全球专用网络。组网中使用的云服务、国际专线等资源，除了整合企业自身现有的资源外，外采资源服均可以直接与对应服务商直接签约合作，保证资源的实际归属管理权，我们提供优质的高性价比资源渠道、技术搭建与后续维护迭代服务。
            </div>
            <div className="w-[170px] h-[60px] bg-gradient-to-br from-[#5F97FF] to-[#0182FF] rounded-[10px] flex items-center justify-center mt-[30px]">
              <a
                href="https://t22qshgkpd.jiandaoyun.com/f/68cb7a5580eabb69297c524b"
                target="_blank"
              >
                <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[25px] text-[#FFFFFF]">
                  联系部署
                </div>
              </a>
            </div>
          </div>
          <img
            className="w-[593px] h-[497px] min-w-[593px] min-h-[497px]"
            src="/imgs/private/4.png"
          />
        </div>
      </div>
    </div>
  );
};
